(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["milkweed-patch-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('milkweed-patch-request')) {
    customElements.define('milkweed-patch-request', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-patch-open]');
        if (!this.dialog || !this.trigger) return;
        this.trigger.addEventListener('click', (event) => {
          if (typeof this.dialog.showModal !== 'function') return;
          event.preventDefault();
          this.dialog.showModal();
        });
        this.querySelector('[data-patch-close]').addEventListener('click', () => this.dialog.close());
        this.addEventListener('submit', (event) => {
          if (event.target === this.querySelector('form') && this.dialog.open) this.dialog.close();
        }, true);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.trigger.focus({preventScroll: true}));
        const feedback = this.querySelector('[data-patch-feedback]');
        if (feedback && (location.hash === '#' + this.dialog.id || new URLSearchParams(location.search).has('patch_request'))) {
          this.dialog.showModal();
          feedback.focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
